/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {AccessTokenIDataResult} from '../models/AccessTokenIDataResult'
import type {IResult} from '../models/IResult'
import type {UserDtoIDataResult} from '../models/UserDtoIDataResult'
import type {UserForForgotPasswordDto} from '../models/UserForForgotPasswordDto'
import type {UserForLoginDto} from '../models/UserForLoginDto'
import type {UserForRegisterDto} from '../models/UserForRegisterDto'
import type {UserForResetPasswordDto} from '../models/UserForResetPasswordDto'
import type {UserForUpdatePasswordDto} from '../models/UserForUpdatePasswordDto'

import type {CancelablePromise} from '../core/CancelablePromise'
import {OpenAPISMA} from 'rest'
import {request as __request} from '../core/request'
import {UserForNewPasswordDto} from 'rest/models/UserForNewPasswordDto'

type VerifyResult = {email_verified: boolean}

export class AuthService {
  /**
   * @param requestBody
   * @returns AccessTokenIDataResult Success
   * @throws ApiError
   */
  public static postApiAuthLogin(
    requestBody?: UserForLoginDto
  ): CancelablePromise<AccessTokenIDataResult> {
    return __request(OpenAPISMA, {
      method: 'POST',
      url: '/api/v1/auth/email-login/',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  public static postApiAuthSetPassword(
    requestBody?: UserForNewPasswordDto
  ): CancelablePromise<UserForNewPasswordDto> {
    return __request(OpenAPISMA, {
      method: 'POST',
      url: '/api/v1/auth/set-new-password/',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param requestBody
   * @returns AccessTokenIDataResult Success
   * @throws ApiError
   */
  public static getAuthUser(): CancelablePromise<{data: UserForLoginDto}> {
    if (!localStorage.getItem('user')) {
      return
    }
    return __request(OpenAPISMA, {
      method: 'GET',
      url: '/api/v1/auth/me/',
      transformResponse: result => {
        const localUser = JSON.parse(localStorage.getItem('user'))
        localUser.coupon_center_txn = result.data.coupon_center_txn
        localUser.store = result.data.store
        localStorage.setItem('user', JSON.stringify(localUser))

        return result
      },
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param requestBody
   * @returns AccessTokenIDataResult Success
   * @throws ApiError
   */
  public static postApiAuthRegister(
    requestBody?: UserForRegisterDto
  ): CancelablePromise<AccessTokenIDataResult> {
    return __request(OpenAPISMA, {
      method: 'POST',
      url: '/api/v1/auth/email-register/',
      body: {
        ...requestBody,
        first_name: 'N/A',
        last_name: 'N/A',
      },
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @returns UserDtoIDataResult Success
   * @throws ApiError
   */
  public static postApiAuthVerify(payload: {
    token: string
  }): CancelablePromise<VerifyResult> {
    return __request(OpenAPISMA, {
      method: 'POST',
      body: {
        token: payload.token,
      },
      url: '/api/v1/auth/verify-email/',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param requestBody
   * @returns IResult Success
   * @throws ApiError
   */
  public static postApiAuthForgotPassword(
    requestBody?: UserForForgotPasswordDto
  ): CancelablePromise<IResult> {
    return __request(OpenAPISMA, {
      method: 'POST',
      url: '/api/v1/auth/password-reset',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param requestBody
   * @returns UserDtoIDataResult Success
   * @throws ApiError
   */
  public static postApiAuthResetPassword(
    requestBody?: UserForResetPasswordDto
  ): CancelablePromise<UserDtoIDataResult> {
    return __request(OpenAPISMA, {
      method: 'POST',
      url: '/api/Auth/resetPassword',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param requestBody
   * @returns IResult Success
   * @throws ApiError
   */
  public static postApiAuthUpdatePassword(
    requestBody?: UserForUpdatePasswordDto
  ): CancelablePromise<IResult> {
    return __request(OpenAPISMA, {
      method: 'POST',
      url: '/api/Auth/updatePassword',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param token
   * @returns AccessTokenIDataResult Success
   * @throws ApiError
   */
  public static getApiAuthrefresh(
    token?: string
  ): CancelablePromise<AccessTokenIDataResult> {
    return __request(OpenAPISMA, {
      method: 'GET',
      url: '/api/Auth/refresh',
      query: {
        token: token,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }
}
